module.exports = __webpack_public_path__ + "static/media/gi.06692140.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/gi.svg
// module id = 2099
// module chunks = 0